type ExitIntentSessionState = {
  visits: number;
  triggers: number;
};

type ExitIntentLocalState = {
  disableUntil: string | undefined;
};

/**
 * creates a state object with sync to store.
 *
 * This is needed because the stencil stores works with dynamic setters and the state is saved as complex object
 * for multiple exit-intent instances and so property changes will not trigger the setter of the store. Every time we
 * change a state property the state has to be set as a new object in the store.
 */
export class ExitIntentStateProxy {
  protected sessionStore: ExitIntentSessionState[];
  protected localStore: ExitIntentLocalState[];
  protected id;

  constructor(id: string, stateSessionStore, stateLocalStore) {
    this.id = id;
    this.sessionStore = stateSessionStore;
    this.localStore = stateLocalStore;

    // check if state is existing in store
    if (!this.sessionStore[this.id]) {
      this.sessionStore[this.id] = {
        triggers: 0,
        visits: 0,
      } as ExitIntentSessionState;
    }

    if (!this.localStore[this.id]) {
      this.localStore[this.id] = {
        disableUntil: undefined,
      } as ExitIntentLocalState;
    }
  }

  get triggers() {
    return this.sessionStore[this.id].triggers;
  }

  get visits() {
    return this.sessionStore[this.id].visits;
  }

  get disableUntil(): Date | null {
    return this.localStore[this.id].disableUntil ? new Date(this.localStore[this.id].disableUntil) : null;
  }

  set disableUntil(disableDate: Date | undefined) {
    this.localStore[this.id] = { ...this.localStore[this.id], disableUntil: disableDate.toUTCString() }; // needs to be a new object to trigger the getter in the store
  }

  public increaseVisit() {
    this.sessionStore[this.id] = { ...this.sessionStore[this.id], visits: ++this.sessionStore[this.id].visits }; // needs to be a new object to trigger the getter in the store
  }

  public increaseTrigger() {
    this.sessionStore[this.id] = { ...this.sessionStore[this.id], triggers: ++this.sessionStore[this.id].triggers }; // needs to be a new object to trigger the getter in the store
  }
}
